/*
 * Public API of @fido/firebase (primary entry point).
 *
 * Hosts shared internals: pendingUntilEvent re-export and the kdvWrap helper
 * that wraps Firebase / rxfire functions for SSR pending-task tracking and
 * run-in-injection-context callback wrapping. Per-domain APIs live in
 * secondary entry points (@fido/firebase/firestore, /auth, /functions, ...).
 */

export { kdvWrap } from './lib/kdv-wrap';
export { pendingUntilEvent, trackPending, trackPendingPromise } from './lib/pending';

// Test utilities. Tree-shaken from production app bundles that don't import them.
export { makeUser, setupFirebaseTest, type FirebaseTestHandles } from './lib/testing';
